import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'
import VueFusionCharts from 'vue-fusioncharts';
import Column2D from 'fusioncharts/fusioncharts.charts';
import Widgets from 'fusioncharts/fusioncharts.widgets';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import FusionCharts from 'fusioncharts';
import pt from 'vuetify/es5/locale/pt';

Vue.use(Vuetify);
Vue.use(Chartkick.use(Chart));
Vue.use(VueFusionCharts, FusionCharts, Column2D, Widgets, FusionTheme);

export default new Vuetify({
    lang:{
        locales: { pt },
        current: 'pt'
    }
});
